module.exports = __webpack_public_path__ + "static/media/01.ced421f9.jpg";